/*
 * MEPP - A web application to guide patients and clinicians in the process of
 * facial palsy rehabilitation, with the help of the mirror effect and principles
 * of motor learning
 * Copyright (C) 2021 MEPP <info@mirroreffectplus.org>
 *
 * This file is part of MEPP.
 *
 * MEPP is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * MEPP is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with MEPP.  If not, see <http://www.gnu.org/licenses/>.
 */

export default {
  exercise: {
    name: 'Esercizio',
    rest: 'Riposatevi un momento.',
    pause: 'Sei in pausa',
    pauseMessage:
      'Prenditi il tuo tempo e quando sei pronto premi il pulsante qui sotto.',
    complete: 'Esercizio terminato.',
    end: 'Congratulazioni! Sei arrivato alla fine della tua sessione di esercizi. Continua così: la perseveranza è una condizione essenziale per il tuo successo.',
    empty:
      'Nessun piano d’intervento è stato ancora creato per te. Contatta il tuo clinico per attivare il tuo profilo di esercizi.',
  },
};
